<template>
  <b-modal
    header-close-content=""
    ref="summary"
    :title="$t('Automapping.AutomappingShowStatisticsTitle')"
    v-model="viewModel.showModal"
    data-cy="channel-creator-automapping-summary-modal">
    <div>
      <b-container fluid>
        <b-row>
          <b-col cols="12"
            ><h6>{{ $t("AutoMapping.Summary.Subtitle") }}</h6></b-col
          >
        </b-row>
        <b-row>
          <b-col cols="6">{{ $t("AutoMapping.Summary.catalogMappingsCount") }} :</b-col>
          <b-col>{{ props.summary.catalogMappingsCount ?? 0 }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="6">{{ $t("AutoMapping.Summary.globalMappingsCount") }} :</b-col>
          <b-col>{{ props.summary.globalMappingsCount ?? 0 }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="6">{{ $t("AutoMapping.Summary.invariantAttributeMappingsCount") }} :</b-col>
          <b-col>{{ props.summary.invariantAttributeMappingsCount ?? 0 }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="6">{{ $t("AutoMapping.Summary.variantAttributeMappingsCount") }} :</b-col>
          <b-col>{{ props.summary.variantAttributeMappingsCount ?? 0 }}</b-col>
        </b-row>
      </b-container>
    </div>
    <template #modal-footer="{ ok }">
      <b-btn @click="ok" data-cy="channel-creator-automapping-summary-close-btn">{{ $t("Close") }}</b-btn>
    </template>
  </b-modal>
</template>
<script setup context lang="ts">
import { reactive } from "vue";
import { MappingGenerationResultModel } from "@medapro-types/ChannelCreator/components/AutoMappingTab";

//#region General
const props = defineProps<{ summary: MappingGenerationResultModel }>();
//#endregion

//#region ViewModel
type ViewModel = { showModal: boolean };
const viewModel = reactive<ViewModel>({ showModal: false });
//#endregion

//#region Methods
const show = () => {
  viewModel.showModal = true;
};
defineExpose({
  show: show
});
//#endregion
</script>
